import {
  Box,
  Flex,
  Heading,
  useColorModeValue,
  Text,
  Image,
  Badge,
} from "@chakra-ui/react";
import moment from "moment";
import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Outlet } from "../../data/outlets.api";

type Props = {
  outlet: Outlet;
};

const OutletCard = ({ outlet }: Props) => {
  const navigate = useNavigate();
  const bg = useColorModeValue("gray.50", "gray.700");
  const hoverColour = useColorModeValue("gray.100", "gray.600");

  const openingHoursIn = useMemo(() => {
    const today = moment().format("dddd");
    const openingHours = outlet.openingHours.daysOfWeek.find(
      (day) => day.day === today
    );
    if (openingHours && !openingHours.closed) {
      const openingTime = moment(openingHours.openFrom, "HH:mm");
      const closingTime = moment(openingHours.openTo, "HH:mm");
      if (openingTime.isAfter(moment())) {
        return `Opening ${openingTime.toNow()}`;
      } else if (closingTime.isAfter(moment())) {
        return `Closing ${closingTime.fromNow()}`;
      } else {
        return `Closed ${closingTime.fromNow()}`;
      }
    }
  }, [outlet]);

  return (
    <Flex
      border="1px solid rgba(0, 0, 0, 0.1)"
      rounded="md"
      overflow="hidden"
      role="group"
      bg={bg}
      cursor="pointer"
      transition=".1s all"
      _hover={{ bg: hoverColour }}
      onClick={() => navigate(`/outlets/${outlet.businessID}`)}
    >
      <Flex p={5} flex={1} gap={3}>
        <Flex direction="column" flex={1}>
          <Heading size="sm">
            {outlet.name}{" "}
            <Badge colorScheme={outlet.isOpen ? "green" : "red"}>
              {outlet.isOpen ? "Open" : "Closed"}
            </Badge>
          </Heading>
          <Text fontSize="xs" opacity={0.7}>
            {outlet.department}
          </Text>
          <Text fontSize="xs" opacity={0.5}>
            {openingHoursIn}
          </Text>
        </Flex>
      </Flex>
      <Box
        bg={`url(${outlet.imageURL})`}
        bgSize="cover"
        bgPosition="center"
        w={24}
      />
    </Flex>
  );
};

export default OutletCard;
